export const ACCOUNT_URL = "https://alpha.tradrquant.com/account";
const KEY = "tq_ref";

export const captureRef = () => {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem(KEY, ref);
  } catch { /* storage blocked */ }
};

export const accountUrl = () => {
  let ref = "";
  try { ref = new URLSearchParams(window.location.search).get("ref") || localStorage.getItem(KEY) || ""; } catch { /* storage blocked */ }
  return ref ? `${ACCOUNT_URL}?ref=${encodeURIComponent(ref)}` : ACCOUNT_URL;
};

export const goToAccount = () => window.location.assign(accountUrl());
